
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
@Component({
  name: "RadioHeader",
  components: {},
})
export default class RadioHeader extends Vue {
  @Prop({ type: Array, required: false }) btnList?: any;
  @Prop({ type: Number }) active?: any;
  @Prop({ type: String }) placeholder?: any;
  searchValue: any = "";
  handleClickBtn(index: any) {
    this.$emit("handleClickBtn", index);
  }
  handleClickMore() {
    this.$emit("handleClickMore");
  }
  search() {
    this.$emit("search", { title: this.searchValue });
  }
}
